import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import clsx from 'clsx';
import * as Yup from 'yup';
import {Formik} from 'formik';
import {Box, Button, TextField, FormHelperText, makeStyles} from '@material-ui/core';
import {login} from 'src/store/actions/accountActions';
import {locales} from 'src/sections/locales';

const useStyles = makeStyles(() => ({
    root: {},
}));

export const LoginForm = ({className, onSubmitSuccess}: {className?: string; onSubmitSuccess: () => void}) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    return (
        <Formik
            initialValues={{
                email: '',
                password: '',
            }}
            validationSchema={Yup.object().shape({
                email: Yup.string().required(locales.required),
                password: Yup.string().required(locales.required),
            })}
            onSubmit={async (values, {setErrors, setStatus, setSubmitting}) => {
                try {
                    await dispatch(login(values.email, values.password));
                    onSubmitSuccess();
                } catch (error) {
                    const message = (error.response && error.response.data.message) || locales.genericErrorShort;

                    setStatus({success: false});
                    setErrorMessage(message);
                    setSubmitting(false);
                }
            }}
            validateOnBlur={false}
        >
            {({errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values}) => (
                <form noValidate className={clsx(classes.root, className)} onSubmit={handleSubmit}>
                    <TextField
                        error={Boolean(touched.email && errors.email)}
                        fullWidth
                        autoFocus
                        helperText={touched.email && errors.email}
                        label={locales.login}
                        margin='normal'
                        name='email'
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type='text'
                        value={values.email}
                        variant='outlined'
                    />
                    <TextField
                        error={Boolean(touched.password && errors.password)}
                        fullWidth
                        helperText={touched.password && errors.password}
                        label='Password'
                        margin='normal'
                        name='password'
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type='password'
                        variant='outlined'
                    />
                    <Box mt={2}>
                        <Button
                            color='secondary'
                            disabled={isSubmitting}
                            fullWidth
                            size='large'
                            type='submit'
                            variant='contained'
                        >
                            Log In
                        </Button>
                        {errorMessage && (
                            <Box mt={3}>
                                <FormHelperText error>{errorMessage}</FormHelperText>
                            </Box>
                        )}
                    </Box>
                </form>
            )}
        </Formik>
    );
};
